<template>
  <div class="app-container">
    <div v-show="!hasGiftSub" class="lookup-form-section">
      <h3 class="page-title">
        Just received a world tour of coffee?
      </h3>
      <h4 class="sub-title">
        You can look up your order and find your gift here!
      </h4>
      <div class="errors">
        {{ errors }}
      </div>
      <div class="success" />
      <div id="lookup-gift-container">
        <div class="input-wrapper">
          <label for="zip_code">Enter your zip code</label>
          <input v-model="form.zipCode" type="text"
                 placeholder
                 @click="sendAnalytics('gift_claim_click', { linkText: 'Enter your zip code', linkType: 'text_input' })"
          />
        </div>
        <div class="input-wrapper">
          <label for="shipment_id" class="">
            <div class="lh1">
              Enter your Order #
            </div>
            <span class="link lookup-help" href="https://assets.atlascoffeeclub.com/gift-lookup-help.jpg" @click="sendAnalytics('gift_claim_click', { linkText: 'Instructions Here', linkType: 'hyperlink' })">
              Instructions Here
            </span>
          </label>
          <input v-model="form.orderNumber" type="text"
                 placeholder
                 @click="sendAnalytics('gift_claim_click', { linkText: 'Enter your order #', linkType: 'text_input' })"
          />
          <div class="no-order-number">
            Don't have your order number?
            <br>
            <span class="underline pointer" @click="showLastName = true; sendAnalytics('gift_claim_click', { linkText: 'Click here to enter your Last Name instead', linkType: 'hyperlink' })">Click here to enter your <span class="bold">Last Name</span> instead</span>
          </div>
        </div>
        <div v-show="showLastName" class="input-wrapper">
          <label for="zip_code">Enter your Last Name</label>
          <input v-model="form.lastName" type="text"
                 placeholder
                 @click="sendAnalytics('gift_claim_click', { linkText: 'Enter your last name', linkType: 'text_input' })"
          />
        </div>
        <div class="input-wrapper">
          <div class="extend-cta-link">
            <a id="confirm-extend"
               href="#"
               class="uppercase butn butn-yellow"
               @click="lookupOrder"
            >Find My Gift</a>
          </div>
        </div>
      </div>
      <div v-if="lookupResults" style="color: #cc0000;">
        {{ lookupResults }}
      </div>
      <div class="lost-box-container">
        <span class="lost-box" @click="showSupportForm = true; sendAnalytics('gift_claim_click', { linkText: 'Need Help? Send us a message here.', linkType: 'hyperlink' })">
          Need help? Send us a message here.
        </span>
      </div>
      <div v-show="showSupportForm" class="support-container form-container">
        <div class="form-group">
          <input v-model="supportForm.email" type="text"
                 placeholder="Your email"
                 @click="sendAnalytics('gift_claim_click', { linkText: 'Your email', linkType: 'text_input' })"
          />
        </div>
        <div class="form-group">
          <input v-model="supportForm.senderName" type="text"
                 placeholder="Gift sender name (optional)"
                 @click="sendAnalytics('gift_claim_click', { linkText: 'Gift sender name', linkType: 'text_input' })"
          />
        </div>
        <div class="form-group">
          <input v-model="supportForm.name" type="text"
                 placeholder="Your name"
                 @click="sendAnalytics('gift_claim_click', { linkText: 'Your name', linkType: 'text_input' })"
          />
        </div>
        <div class="form-group">
          <textarea v-model="supportForm.address" type="text"
                    rows="3"
                    placeholder="Shipping address" @click="sendAnalytics('gift_claim_click', { linkText: 'Shipping address', linkType: 'text_input' })"
          />
        </div>
        <div class="extend-cta-link">
          <a :key="mailSupportLink"
             class="uppercase button butn butn-yellow"
             target="_blank"
             @click.prevent="emailSupport"
          >Email Support</a>
        </div>
        <div v-if="emailResults" :class="{ 'text-red-600': emailErrorMessage }">
          {{ emailResults }}
        </div>
      </div>
    </div>

    <div v-show="hasGiftSub" class="lookup-success">
      <div class="success-header">
        Hi<span v-if="giftSub.to_name" class="to-name"> {{ giftSub.to_name }}</span>!
      </div>
      <div class="welcome">
        — welcome to your ⁠—
      </div>
      <div class="months">
        {{ giftSub.months }} Month World Tour of Coffee!
      </div>
      <div v-show="giftSub.note" class="note-header">
        Gift Note:
      </div>
      <div class="gift-note">
        {{ giftSub.note }}<br><span v-show="giftSub.note">
          From: {{ giftSub.from_name }}</span>
      </div>

      <div class="register-container form-container">
        <div class="account-title">
          Register to choose your<br>coffee preferences
        </div>
        <div class="register-fields">
          <div class="clearfix form-group">
            <div class="col-1-2">
              <input v-model="registerForm.firstName" type="text" placeholder="First Name" />
            </div>
            <div class="col-1-2">
              <input v-model="registerForm.lastName" type="text" placeholder="Last Name" />
            </div>
          </div>
          <div class="form-group">
            <input v-model="registerForm.email" type="text" placeholder="Your email" />
          </div>
          <div class="form-group">
            <input v-model="registerForm.password" type="password" placeholder="Password" />
          </div>
          <!--div class="form-group">
              <%= password_field_tag :password_confirm, nil, placeholder: "Confirm Password" %>
            </div-->
          <div class="form-group">
            <input type="submit"
                   :value="!isRegistering ? 'Create Your account' : 'Creating Account...'"
                   @click="registerGift"
            />
          </div>
          <div v-if="registerErrors" class="register-errors">
            {{ registerErrors }}
          </div>
        </div>
        <div class="fine-print">
          *You do not need to create an account to receive your remaining shipments
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Luminous } from 'luminous-lightbox';
import { parse } from 'qs';
import Service from './AccountAPIService';

const service = new Service(window.ATLAS_APP.baseUrl);
export default {
  data() {
    return {
      emailErrorMessage: false,
      isRegistering: false,
      registerErrors: null,
      showSupportForm: false,
      showLastName: false,
      form: {
        orderNumber: null,
        name: null,
        zipCode: null,
      },
      supportForm: {
        email: null,
        senderName: null,
        name: null,
        address: null,
        type: 'gift',
      },
      registerForm: {
        claimCode: null,
        firstName: null,
        lastName: null,
        email: null,
        password: null,
      },
      giftSub: {},
      errors: null,
      lookupResults: null,
      emailResults: null,
    };
  },
  computed: {
    hasGiftSub() {
      return Object.keys(this.giftSub).length !== 0;
    },
    mailSupportLink() {
      const link = 'mailto:support@atlascoffeeclub.com?subject=Gift%20Registration%20Help&body=';
      let body = `Body-goes-here\n${this.supportForm.name}`;
      body += `\n${this.supportForm.address}`;
      return link + encodeURIComponent(body);
    },
  },
  created() {
    try {
      const parsed = parse(location.search.substring(1));
      if (parsed && parsed.orderNumber && parsed.zipCode) {
        this.form.orderNumber = parsed.orderNumber;
        this.form.zipCode = parsed.zipCode;

        this.lookupOrder();
      }
    } catch (ex) {
      console.error(ex);
    }
  },
  mounted() {
    new Luminous(document.querySelector('.lookup-help'));
  },
  methods: {
    sendAnalytics(event, props) {
      window.analytics && window.analytics.track(event, props);
    },
    emailSupport() {
      this.sendAnalytics('gift_claim_click', { linkText: 'Email Support', linkType: 'button' });
      service
        .emailSupport(this.supportForm)
        .then((response) => {
          const status = response && response.data.status;
          const type = response && response.data.type;
          if (status) {
            if (type == 'error') {
              this.emailErrorMessage = true;
            } else {
              this.emailErrorMessage = false;
            }
            this.emailResults = response.data.status;
          } else {
            this.emailErrorMessage = true;
            this.emailResults = 'There was an error submitting your request. Please reach out to support@atlascoffeeclub.com for further assistance.';
          }
        })
        .catch((error) => {
          this.emailErrorMessage = true;
          this.emailResults = 'There was an error submitting your request. Please reach out to support@atlascoffeeclub.com for further assistance.';
        });
    },
    lookupOrder() {
      this.sendAnalytics('gift_claim_click', { linkText: 'Find My Gift', linkType: 'button' });
      service
        .lookupOrder(this.form)
        .then((response) => {
          const gift = response && response.data.gift;

          if (gift) {
            this.giftSub = gift;
            this.lookupResults = null;
            this.registerForm.claimCode = this.giftSub.claim_code;
          } else {
            this.lookupResults = response.data.status;
            this.sendAnalytics('gift_claim_error', { error_type: response.data.error, error_message: response.data.status });
          }
        }).catch((error) => {
          console.log(error);
          this.lookupResults = 'There was an error looking up your gift. Please reach out to support@atlascoffeeclub.com for further assistance.';
        });
    },
    registerGift() {
      this.isRegistering = true;
      service.registerGift(this.registerForm).then((response) => {
        window.location.href = response && response.data && response.data.redirect_url;
      }).catch((error) => {
        this.registerErrors = 'There was an error registering your gift. Please reach out to support@atlascoffeeclub.com for further assistance.';
        this.isRegistering = false;
      });
    },
  },
};
</script>
<style lang="scss">
.app-container {
  margin-bottom: 30px;
}


.lum-lightbox {
  margin-top: 100px;
}

.bold {
  font-weight: 700;
  color: #5b5a57;

}

.page-title {
  max-width: 478px;
  margin: 0 auto;

  font-family: Lato;
  font-style: normal;
  font-weight: 900;
  font-size: 24px;
  line-height: 30px;
  /* or 125% */

  text-align: center;
  letter-spacing: 0.1em;

  color: #16496A;
}

.sub-title {
  margin-bottom: 28px;
  font-size: 15px;
  line-height: 24px;
  /* or 160% */

  text-align: center;
  letter-spacing: 0.03em;

  color: #333333;
}

.input-wrapper label {
  text-transform: uppercase;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */

  text-align: center;
  letter-spacing: 0.05em;

  color: #333333;

}

.lh1 {
  line-height: 1;
}

.lookup-help {
  border-bottom: 1px dotted #cacacc;
  text-transform: none;
  line-height: 1;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */

  text-align: center;
  letter-spacing: 0.05em;

  color: #5B999D;

  cursor: pointer;
}

.pointer {
  cursor: pointer;
}

.underline {
  text-decoration: underline;
}

.no-order-number {
  margin-top: 10px;
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 20px;
  /* or 133% */

  text-align: center;
  letter-spacing: 0.03em;

  color: #333333;
}

.lost-box-container {
  margin-top: 40px;
}

.lost-box {
  font-weight: 900;
  border-bottom: 1px dotted #cacacc;
  font-size: 18px;
  cursor: pointer;
}

.support-container {
  max-width: 350px;
  text-align: center;
  margin: 0 auto;
}

textarea {
  width: 100%;
}

#lookup-gift-container {
  text-align: center;
  max-width: 300px;
  margin: 0 auto;
}

.lookup-results {
  text-align: center;
  max-width: 600px;
  margin: 0 auto;
}

.register-container {
  max-width: 500px;
  margin: 28px auto 30px;
}

.sub-title {
  text-align: center;
  margin: 0;
  color: #676767;
}

.account-title {
  text-transform: uppercase;
  font-weight: bold;
  font-size: 20px;
  line-height: 1.4;
  /* or 150% */

  text-align: center;
  letter-spacing: 0.1em;

  color: #16496A;
  margin: 37px 0 19px 0;
}

.round-border {
  border: 0.5px solid #cfcfcf;
  border-radius: 3px;
  margin-bottom: 23px;
}

.formError {
  color: red;
}

.status-error {
  color: red;
}

.status-success {
  color: green;
}

.claim-code-status {
  height: 25px;
  text-align: center;
}

.form-group {
  margin: 10px 0;
}

.form-group input[type="submit"] {
  margin-top: 20px;
}

.form-group .col-1-2 {
  padding: 0;
}

.message-header {
  color: #222;
  text-transform: none;
  margin-bottom: 46px;
}

.lookup-success {
  text-align: center;
  letter-spacing: 0.05em;
  color: #333333;
}

.success-header {
  font-weight: bold;
  font-size: 20px;
  line-height: 24px;
  /* or 120% */

  text-align: center;
  letter-spacing: 0.05em;
}

.welcome {
  margin-top: 10px;
  font-size: 16px;
  line-height: 1.2;
  /* or 120% */

  text-align: center;
  letter-spacing: 0.05em;
}

.months {
  font-style: italic;
  font-weight: 900;
  font-size: 18px;
  line-height: 24px;
}

.note-header {
  margin-top: 26px;
  margin-bottom: 5px;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  text-transform: uppercase;
}

.gift-note {
  white-space: pre;
  font-style: italic;
  font-weight: normal;
  font-size: 16px;
  line-height: 1.1;

  text-align: center;
  letter-spacing: 0.03em;
}

.fine-print {
  font-size: 14px;
  line-height: 1.3;
  /* or 129% */
  letter-spacing: 0.03em;
  margin-top: 25px;
}

.register-errors {
  line-height: 1.3;
}
</style>
<style lang="scss" scoped>
div {
  text-align: center;
}
</style>
